(function () {
  'use strict';

  var PREORDER_TAG = 'precommande';
  var NOTICE_ID    = 'mr-preorder-notice';
  var productCache = {};
  var updateTimer  = null;
  var isRunning    = false;
  var pendingRun   = false;

  // ─── Mot-clé déclencheur pour les médailles (sur le NOM du produit) ───────
  // Tout article dont le titre contient « médaille » (accents/casse ignorés)
  // déclenche le MÊME message que les articles en précommande.
  var MEDAILLE_KEY = 'medaille';

  // ─── Normalise une chaîne (minuscules + suppression des accents) ─────────
  function normalize(str) {
    str = (str || '').toLowerCase();
    return str.normalize ? str.normalize('NFD').replace(/[̀-ͯ]/g, '') : str;
  }

  // ─── Un article est-il une médaille ? (détection par le nom) ─────────────
  function isMedaille(item) {
    var name = normalize((item.product_title || '') + ' ' + (item.title || ''));
    return name.indexOf(MEDAILLE_KEY) !== -1;
  }

  // ─── Récupère les données produit (tags + variantes) ─────────────────────
  async function fetchProduct(handle) {
    if (productCache[handle]) return productCache[handle];
    try {
      var res  = await fetch('/products/' + handle + '.js');
      var data = await res.json();
      productCache[handle] = {
        tags:     (data.tags || []).map(function(t){ return t.toLowerCase(); }),
        variants: data.variants || []
      };
    } catch(_) {
      productCache[handle] = { tags: [], variants: [] };
    }
    return productCache[handle];
  }

  // ─── Un article est-il en précommande ? ──────────────────────────────────
  // Critère 1 : le produit a le tag "precommande"
  // Critère 2 : la variante précise est en rupture + politique "continuer"
 function isPreorder(product, variantId) {
    if (product.tags.indexOf(PREORDER_TAG) !== -1) return true;
    return product.tags.indexOf(PREORDER_TAG + '-' + variantId) !== -1;
  }

  // ─── État du panier ───────────────────────────────────────────────────────
  async function getCartState() {
    try {
      var res  = await fetch('/cart.js');
      var cart = await res.json();
      if (!cart.items || !cart.items.length) {
        return { hasPreorder: false, hasAvailable: false };
      }

      var hasPreorder  = false;
      var hasAvailable = false;
      var handles      = [];

      cart.items.forEach(function(item) {
        if (handles.indexOf(item.handle) === -1) handles.push(item.handle);
      });

      await Promise.all(handles.map(function(h){ return fetchProduct(h); }));

      cart.items.forEach(function(item) {
        var p = productCache[item.handle];
        // Médaille (par son nom) OU produit en précommande (par tag) → même message
        if (isMedaille(item) || (p && isPreorder(p, item.variant_id))) hasPreorder  = true;
        else                                                            hasAvailable = true;
      });

      return { hasPreorder: hasPreorder, hasAvailable: hasAvailable };
    } catch(_) {
      return { hasPreorder: false, hasAvailable: false };
    }
  }

  // ─── Injection / mise à jour / suppression du message ────────────────────
  function renderNotice(state) {
    var existing     = document.getElementById(NOTICE_ID);
    var footer       = document.querySelector('.AOV-CartDrawer-Footer');
    var checkoutBtn  = footer && footer.querySelector('.AOV-CartDrawer-Checkout');
    var checkoutWrap = checkoutBtn && checkoutBtn.parentElement;

    if (!state.hasPreorder) {
      if (existing) existing.remove();
      return;
    }
    if (!footer || !checkoutWrap) {
      if (existing) existing.remove();
      return;
    }

    var isMixed = state.hasAvailable;
    var msg = isMixed
      ? "Cette commande contient un ou plusieurs articles en précommande. Elle sera expédiée uniquement lorsque l’intégralité des produits de la commande sera disponible."
      : "Cet article est en précommande et sera expédié dès qu’il sera disponible.";

    if (existing) {
      var t = existing.querySelector('.mr-preorder-notice__text');
      if (t) t.textContent = msg;
      if (existing.nextElementSibling !== checkoutWrap) footer.insertBefore(existing, checkoutWrap);
      return;
    }

    var el = document.createElement('div');
    el.id        = NOTICE_ID;
    el.className = 'mr-preorder-notice';
    el.setAttribute('role', 'alert');
    el.innerHTML =
      '<div class="mr-preorder-notice__inner">' +
        '<span class="mr-preorder-notice__icon" aria-hidden="true">' +
          '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" width="15" height="15">' +
            '<circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>' +
          '</svg>' +
        '</span>' +
        '<p class="mr-preorder-notice__text">' + msg + '</p>' +
      '</div>';
    footer.insertBefore(el, checkoutWrap);
  }

  // ─── Orchestration ────────────────────────────────────────────────────────
  async function runUpdate() {
    if (isRunning) { pendingRun = true; return; }
    isRunning = true;
    try   { renderNotice(await getCartState()); }
    finally {
      isRunning = false;
      if (pendingRun) { pendingRun = false; runUpdate(); }
    }
  }

  function scheduleUpdate(ms) {
    clearTimeout(updateTimer);
    updateTimer = setTimeout(runUpdate, ms || 450);
  }

  // ─── Interception fetch — capte TOUT ajout / retrait / modif du panier ───
  var CART_WRITE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;

  var _fetch = window.fetch;
  window.fetch = function(input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var res = _fetch.apply(this, arguments);
    if (CART_WRITE.test(url)) {
      productCache = {};
      res.then(function(){ scheduleUpdate(500); }).catch(function(){});
    }
    return res;
  };

  // ─── Fallback XHR (certains thèmes anciens utilisent XHR) ─────────────────
  var _xhrOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(method, url) {
    if (typeof url === 'string' && CART_WRITE.test(url)) {
      this.addEventListener('load', function(){ productCache = {}; scheduleUpdate(600); });
    }
    return _xhrOpen.apply(this, arguments);
  };

  // ─── MutationObserver — re-injecte si AOV recrée le footer ───────────────
  function watchDrawer() {
    var root = document.getElementById('aov-cart-drawer');
    if (!root) return;
    new MutationObserver(function(mutations) {
      var isOwn = mutations.every(function(m) {
        return [].concat(Array.from(m.addedNodes), Array.from(m.removedNodes))
          .every(function(n){
            return n.id === NOTICE_ID ||
                   (n.nodeType === 1 && n.closest && n.closest('#' + NOTICE_ID));
          });
      });
      if (!isOwn) scheduleUpdate(350);
    }).observe(root, { childList: true, subtree: true });
  }

  // ─── Init ─────────────────────────────────────────────────────────────────
  function init() { watchDrawer(); scheduleUpdate(700); }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();

})();
